import { AxiosService } from './axios.service'

const baseURL = 'bilhete-usuario'

/**
 * Defines the API methods for an user ticket
 */
export class UserTicketService {
	/**
	 * Gets the list of user tickets
	 * @return {Promise<any[]>} lista de bilhetes informados pelo usuário
	 */
	static getTickets() {
		return AxiosService.get(baseURL).then(({ data }) => ({
			totalRows: data.data.length,
			rows: data.data.map(item => ((item.partner = 'Planalto'), item))
		}))
	}

	/**
	 * Register a ticket
	 */
	static registerTicket(params) {
		return AxiosService.put(baseURL, params).then(({ data }) => data)
	}
}
